import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontFamily: typography.fontFamily,
        minHeight: '52px',
        maxWidth: '400px',
        background: semantic.bg.default,
        color: semantic.text.stronger.neutral,
        linkColor: semantic.text.primary,
        closeColor: semantic.text.strong.neutral,
        title: {
            fontSize: typography.fontSize.bodyLargeBold,
            fontWeight: typography.fontWeight.bodyLargeBold,
            lineHeight: typography.lineHeight.bodyLargeBold,
        },
        info: {
            background: semantic.fill.subtler.primary,
            borderColor: semantic.border.primary,
            iconColor: semantic.icon.primary,
        },
        success: {
            background: semantic.fill.subtler.success,
            borderColor: semantic.border.success,
            iconColor: semantic.icon.success,
        },
        warn: {
            background: semantic.fill.subtler.warning,
            borderColor: semantic.border.warning,
            iconColor: semantic.icon.warning,
        },
        error: {
            background: semantic.fill.subtler.error,
            borderColor: semantic.border.error,
            iconColor: semantic.icon.error,
        },
    };
}
